// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"9404b875","769":"efba1ff5"}[chunkId] + ".chunk.css";
};